import {post} from './';

export const promoteList = (body) => {
  const url = '/api/promote/list'
  return post(url, body)
}

export const promoteGet = (body) => {
  const url = '/api/promote/get'
  return post(url, body)
}

export const promoteCount = (body) => {
  const url = '/api/promote/count'
  return post(url, body)
}

export const getPromoteCodebyID = (body) => {
  const url = '/api/promote/get-code-by-id'
  return post(url, body)
}
